export const API_GET_ROUND = 'API_GET_ROUND';
export const API_GET_ROUND_SUCCESS = 'API_GET_ROUND_SUCCESS';
export const API_GET_ROUND_FAIL = 'API_GET_ROUND_FAIL';

export const API_GET_CURRENT_ROUND = 'API_GET_CURRENT_ROUND';
export const API_GET_CURRENT_ROUND_SUCCESS = 'API_GET_CURRENT_ROUND_SUCCESS';
export const API_GET_CURRENT_ROUND_FAIL = 'API_GET_CURRENT_ROUND_FAIL';

export const API_GET_BY_DATE_ROUND = 'API_GET_BY_DATE_ROUND'
export const API_GET_BY_DATE_ROUND_SUCCESS = 'API_GET_BY_DATE_ROUND_SUCCESS'
export const API_GET_BY_DATE_ROUND_FAIL = 'API_GET_BY_DATE_ROUND_FAIL'

export const API_ASSIGN_ROUND = 'API_ASSIGN_ROUND'
export const API_ASSIGN_ROUND_SUCCESS = 'API_ASSIGN_ROUND_SUCCESS'
export const API_ASSIGN_ROUND_FAIL = 'API_ASSIGN_ROUND_FAIL'

export const API_UNASSIGN_ROUND = 'API_UNASSIGN_ROUND'
export const API_UNASSIGN_ROUND_SUCCESS = 'API_UNASSIGN_ROUND_SUCCESS'
export const API_UNASSIGN_ROUND_FAIL = 'API_UNASSIGN_ROUND_FAIL'

export const API_PATCH_APPOINTMENT = 'API_PATCH_APPOINTMENT';
export const API_PATCH_APPOINTMENT_SUCCESS = 'API_PATCH_APPOINTMENT_SUCCESS';
export const API_PATCH_APPOINTMENT_FAIL = 'API_PATCH_APPOINTMENT_FAIL';

export const API_END_ROUND = 'API_END_ROUND'
export const API_END_ROUND_FAIL = 'API_END_ROUND_FAIL'
export const API_END_ROUND_SUCCESS = 'API_END_ROUND_SUCCESS'

export const API_GET_SYNC_ROUNDS = 'API_GET_SYNC_ROUNDS'
export const API_GET_SYNC_ROUNDS_FAIL = 'API_GET_SYNC_ROUNDS_FAIL'
export const API_GET_SYNC_ROUNDS_SUCCESS = 'API_GET_SYNC_ROUNDS_SUCCESS'